import Icon from "./logo";
var CnLayoutCellPrototype = {
  title: '容器',
  componentName: 'CnLayoutCell',
  // category: '图表',
  icon: Icon,
  docUrl: '',
  isContainer: true,
  // canResizing: true,
  // onResizeStart: (e, node) => {
  //   // eslint-disable-next-line no-console
  //   console.log('onResizeStart', e, node);
  // },
  // onResize: (e, node) => {
  //   // eslint-disable-next-line no-console
  //   console.log('onResize', e, node);
  // },
  // onResizeEnd: (e, node) => {
  //   // eslint-disable-next-line no-console
  //   console.log('onResizeEnd', e, node);
  // },
  configure: [{
    name: 'isCnLayoutCell',
    title: 'CnLayoutCell',
    initialValue: true,
    display: 'none'
  }, {
    name: '_context',
    title: '上下文',
    initialValue: {
      type: 'JSExpression',
      value: 'this'
    },
    display: 'none'
  }]
};
// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype

export { CnLayoutCellPrototype };